import { reduxType } from "../../interfaces/reducerType"
const defaultState: any = {
    isVisible: false,
    record: [],
    key: ""
}
function reducer(state = defaultState, { type, payload }: reduxType) {
    switch (type) {
        case "setRegionalGroupCreate":
            return payload
        default:
            return state;
    }
}
export default reducer;